var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h2',{staticClass:"c-title c-title--page"},[_vm._v(_vm._s(_vm.$t('eventDiscipline.edit')))]),_c('event-discipline',{attrs:{"id":_vm.$route.params.disciplineId,"eventId":_vm.$route.params.eventId},on:{"submit":function($event){return _vm.update($event)},"remove":function($event){return _vm.remove($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }